import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getRequest, updateRequest, postRequest } from "../services";
import { userAvatar } from "../Constant/images";
import { pencilSvg } from "../Constant/svgs";
import UserMeta from "../Components/Common/UserMeta";
import ClassDetails from "./ClassesDetails";
import ChangePassword from "./ChangePassword";
import { DatePicker, message, Spin, Button } from "antd";
import dayjs from "dayjs";
import DashboardModal from "../modals/Hrms/DashboardModal";
import ApplyLeaveModal from "../modals/Hrms/ApplyLeaveModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchAssignedLeavesByEmail } from "../redux/assignLeaveSlice";
import { applyLeave } from "../redux/applyLeaveSlice";
import { fetchTeachers } from "../redux/teachersSlice";

const UserGenInfoTeacher = () => {
  const [genInfo, setGenInfo] = useState({
    firstName: "",
    lastName: "",
    designation: "",
    email: "",
    phone: "",
    location: "",
    cnic: "",
    salary: "",
    dob: "",
    gender: "",
    profilePicture: "",
    joinDate: "",
  });
  const [initialGenInfo, setInitialGenInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [leavesLoading, setLeavesLoading] = useState(false);
  const [isApplyLeaveModalOpen, setIsApplyLeaveModalOpen] = useState(false);
  const auth = JSON.parse(localStorage.getItem("user"));
  const [avatar, setAvatar] = useState(userAvatar);
  const [imageFile, setImageFile] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const dispatch = useDispatch();
  const {
    assignedLeaves,
    status: assignStatus,
    error: assignError,
  } = useSelector((state) => state.assignLeave);
  const { teachers } = useSelector((state) => state.teachers);

  const { t, i18n } = useTranslation();
  const isArabic = i18n.language;

  useEffect(() => {
    const fetchDataUser = async () => {
      try {
        const response = await getRequest(
          `/api/User/GetUserById/${auth.userId}`
        );
        const data = response.data.data;
        const newGenInfo = {
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          designation: data.userType || "",
          email: data.email || "",
          phone: data.phone || "",
          location: data.location || "",
          cnic: data.cnic || "",
          salary: data.salary || "",
          dob: data.dob || "",
          gender: data.gender || "",
          profilePicture: data.profilePicture || "",
          joinDate: data.joiningDate || "",
        };

        setGenInfo(newGenInfo);
        setInitialGenInfo(newGenInfo);

        if (data.profilePicture) {
          setAvatar(data.profilePicture);
        }
      } catch (error) {
        console.error("Error fetching user data:", error.message);
        message.error(t("failedToFetchUserData"));
      }
    };

    fetchDataUser();
  }, [auth.userId, t]);

  useEffect(() => {
    // Fetch teachers to ensure we have the teacher's data
    dispatch(fetchTeachers({ pageNumber: 1, pageSize: 100 }));

  }, [genInfo.email, dispatch, t]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatar(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGenInfo({ ...genInfo, [name]: value });
  };

  const handleDateChange = (date) => {
    setGenInfo({ ...genInfo, dob: date ? date.format("YYYY-MM-DD") : "" });
  };

  const isFormChanged = () => {
    return (
      JSON.stringify(genInfo) !== JSON.stringify(initialGenInfo) ||
      imageFile !== null
    );
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      let profilePictureUrl = null;

      if (imageFile) {
        const imageFormData = new FormData();
        imageFormData.append("files", imageFile);
        const imageResponse = await postRequest(
          "/api/Document/documents-upload",
          imageFormData,
          true
        );
        profilePictureUrl = imageResponse?.data[0];
      }

      if (profilePictureUrl) {
        genInfo.profilePicture = profilePictureUrl;
      }

      const response = await updateRequest(
        `/api/Teacher?id=${auth.userId}`,
        genInfo
      );
      if (response.status === 200) {
        message.success(t("teacherInfoUpdated"));
        setInitialGenInfo(genInfo);
        setImageFile(null);

        const updatedUser = {
          ...auth,
          ...genInfo,
          joiningDate: genInfo.joinDate,
        };
        localStorage.setItem("user", JSON.stringify(updatedUser));
      }
    } catch (error) {
      console.error("Error updating teacher info:", error.message);
      message.error(t("failedToUpdateTeacherInfo"));
    } finally {
      setLoading(false);
    }
  };

  const onApplyLeaveSubmit = async (data) => {
    try {
      // The data already contains teacherEmail from the modal
      const result = await dispatch(applyLeave(data)).unwrap();
      message.success(t("leaveAppliedSuccessfully"));
      setIsApplyLeaveModalOpen(false);
      
      // Refresh assigned leaves to show updated balance
      dispatch(fetchAssignedLeavesByEmail(genInfo.email));
      
      return result;
    } catch (error) {
      console.error("Error applying leave:", error);
      message.error(error.message || t("failedToApplyLeave"));
      throw error; // Re-throw to let the modal handle it
    }
  };

  return (
    <>
      <div className="col-md-4">
        <div className="bg-white p-4 rounded shadow-md mb-3">
          <h3 className="h5 fw-bold">{t("welcome")} 🎉</h3>
          <p className="text-muted">{t("ViewYourReport")}</p>
          <button
            onClick={() => setIsModalOpen(true)}
            className="btn btn-primary mt-3"
            style={{ backgroundColor: "#241763", borderColor: "#7c3aed" }}
          >
            {t("User Dashboard")}
          </button>
        </div>

        <div className="w-100 userProfileWrapper py-4">
          <div className="userMeta w-100 d-flex align-items-center flex-column gap-2 mt-2">
            <div className="avatarWrapper">
              <img
                src={avatar}
                alt="user"
                className="img-fluid rounded-circle"
              />
              <div className="editAvatarImage">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                  id="fileInputTeacher"
                />
                <label htmlFor="fileInputTeacher" style={{ cursor: "pointer" }}>
                  {pencilSvg}
                </label>
              </div>
            </div>
            <h4 className="fw-bold fs-6">{`${genInfo.firstName} ${genInfo.lastName}`}</h4>
            <h6 className="text-secondary">{t("teacher")}</h6>
          </div>
          <UserMeta joinDate={genInfo.joinDate} />
        </div>
      </div>
      <div className="col-md-8">
        <div className="settings w-100 d-flex flex-column gap-3">
          <div className="w-100 py-4 px-4 d-flex flex-column userGenInfoWrapper gap-3">
            <h2 className="heading24px fw-bold text-center">
              {t("GeneralInformation")}
            </h2>
            <div
              className={`row studentProfileHeading ${
                isArabic === "sa" ? "flex-row-reverse" : ""
              }`}
            >
              <div
                className={`col-md-6 ${
                  isArabic === "sa" ? "text-end" : "text-start"
                }`}
              >
                <label htmlFor="firstName" className="form-label">
                  {t("FirstName")}
                </label>
                <div className="mb-3">
                  <input
                    type="text"
                    placeholder={t("firstNamePlaceholder")}
                    className={`form-control ${
                      isArabic === "sa" ? "text-end" : "text-start"
                    }`}
                    name="firstName"
                    onChange={handleChange}
                    value={genInfo.firstName}
                    required
                  />
                </div>
              </div>
              <div
                className={`col-md-6 ${
                  isArabic === "sa" ? "text-end" : "text-start"
                }`}
              >
                <label htmlFor="lastName" className="form-label">
                  {t("LastName")}
                </label>
                <div className="mb-3">
                  <input
                    type="text"
                    placeholder={t("lastNamePlaceholder")}
                    className={`form-control ${
                      isArabic === "sa" ? "text-end" : "text-start"
                    }`}
                    name="lastName"
                    onChange={handleChange}
                    value={genInfo.lastName}
                    required
                  />
                </div>
              </div>
              <div
                className={`col-md-6 ${
                  isArabic === "sa" ? "text-end" : "text-start"
                }`}
              >
                <label htmlFor="email" className="form-label">
                  {t("Email")}
                </label>
                <div className="mb-3">
                  <input
                    type="email"
                    placeholder={t("emailPlaceholder")}
                    className={`form-control ${
                      isArabic === "sa" ? "text-end" : "text-start"
                    }`}
                    name="email"
                    onChange={handleChange}
                    value={genInfo.email}
                    required
                    disabled
                  />
                </div>
              </div>
              <div
                className={`col-md-6 ${
                  isArabic === "sa" ? "text-end" : "text-start"
                }`}
              >
                <label htmlFor="phone" className="form-label">
                  {t("Phone")}
                </label>
                <div className="mb-3">
                  <input
                    type="tel"
                    placeholder="+92"
                    className={`form-control ${
                      isArabic === "sa" ? "text-end" : "text-start"
                    }`}
                    name="phone"
                    onChange={handleChange}
                    value={genInfo.phone || ""}
                    required
                  />
                </div>
              </div>
              <div
                className={`col-md-6 ${
                  isArabic === "sa" ? "text-end" : "text-start"
                }`}
              >
                <label htmlFor="dob" className="form-label">
                  {t("DateOfBirth")}
                </label>
                <div className="mb-3">
                  <DatePicker
                    className={`form-control ${
                      isArabic === "sa" ? "text-end" : "text-start"
                    }`}
                    value={
                      genInfo.dob ? dayjs(genInfo.dob.split("T")[0]) : null
                    }
                    onChange={handleDateChange}
                    format="YYYY-MM-DD"
                    required
                  />
                </div>
              </div>
              <div
                className={`col-md-6 ${
                  isArabic === "sa" ? "text-end" : "text-start"
                }`}
              >
                <label htmlFor="cnic" className="form-label">
                  {t("CNIC")}
                </label>
                <div className="mb-3">
                  <input
                    type="text"
                    placeholder="12345-1234567-1"
                    className={`form-control ${
                      isArabic === "sa" ? "text-end" : "text-start"
                    }`}
                    name="cnic"
                    onChange={handleChange}
                    value={genInfo.cnic}
                  />
                </div>
              </div>
              <div
                className={`col-md-6 ${
                  isArabic === "sa" ? "text-end" : "text-start"
                }`}
              >
                <label htmlFor="salary" className="form-label">
                  {t("Salary")}
                </label>
                <div className="mb-3">
                  <input
                    type="text"
                    placeholder="50000"
                    className={`form-control ${
                      isArabic === "sa" ? "text-end" : "text-start"
                    }`}
                    name="salary"
                    onChange={handleChange}
                    value={genInfo.salary}
                  />
                </div>
              </div>
              <div
                className={`col-md-12 ${
                  isArabic === "sa" ? "text-end" : "text-start"
                }`}
              >
                <label htmlFor="location" className="form-label">
                  {t("Address")}
                </label>
                <div className="mb-3">
                  <textarea
                    placeholder={t("addressPlaceholder")}
                    className={`form-control ${
                      isArabic === "sa" ? "text-end" : "text-start"
                    }`}
                    name="location"
                    onChange={handleChange}
                    value={genInfo.location}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 text-center mt-2">
                  <button
                    className="btn-update"
                    onClick={handleSubmit}
                    disabled={!isFormChanged() || loading}
                    style={{
                      backgroundColor: "#241763",
                      color: "#fff",
                      padding: "10px 20px",
                      borderRadius: "5px",
                    }}
                  >
                    {loading ? <Spin size="small" /> : t("SaveChanges")}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <ClassDetails />
          <ChangePassword />
        </div>
      </div>

      <DashboardModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        teacherEmail={genInfo.email} // Pass teacher's email
      />

      <ApplyLeaveModal
        isModalOpen={isApplyLeaveModalOpen}
        isEdit={false}
        onSubmit={onApplyLeaveSubmit}
        setIsModalOpen={setIsApplyLeaveModalOpen}
        employees={teachers}
      />
    </>
  );
};

export default UserGenInfoTeacher;
